import React from 'react';
import { Carousel } from 'components/carousel/Carousel';

export const DocumentsModalHeader = ({ documentsList, currentDocumentIndex }) => {
    const titlesList = documentsList.map(document => (
        <h4 key={`heading_${document.documentType}`} className={'documents__modal-heading-title'}>
            {document.title}
        </h4>
    ));

    return (
        <div className="documents__modal-heading" role="heading" aria-level="1">
            <Carousel activeIndex={currentDocumentIndex}>{titlesList}</Carousel>
        </div>
    );
};
